<app-page-header title="Home" titleLink="/reports" active_item="Resumo">
</app-page-header>

<form [formGroup]="resumo">
  <div class="row">
    <h5>Resumo de Transações</h5>

    <div class="col-md-12 col-xl-12">
      <div class="card sales-summary shadow rounded-10">
        <div class="card-header">
          <div class="card-title mb-0">{{ "common.filters" | translate }}</div>
          <div class="card-options">
            <a
              href="javascript:void(0)"
              class="card-options-collapse"
              data-bs-toggle="card-collapse"
            >
              <i class="fe fe-chevron"></i>
            </a>
          </div>
        </div>

        <div class="card-body filter-extrato">
          <div class="row">
            <div class="col-xl col-lg-6 col-sm-6">
              <div class="form-group">
                <label class="form-label">
                  {{ "common.initialDate" | translate }}
                </label>

                <mat-form-field
                  appearance="fill"
                  class="w-100 date-align custom-datetime"
                >
                  <input
                    #startText
                    matInput
                    [matDatepicker]="pickerIni"
                    placeholder="DD/MM/YYYY"
                    [formControl]="resumo.controls.initialDate"
                    (input)="startRaw = startText.value"
                    (dateChange)="onDateChange('initialDate', startText.value)"
                    (blur)="parseDateInput('initialDate', startRaw)"
                    (keydown.enter)="parseDateInput('initialDate', startRaw)"
                  />
                  <mat-datepicker-toggle
                    matSuffix
                    [for]="pickerIni"
                  ></mat-datepicker-toggle>
                  <mat-datepicker #pickerIni startView="month"></mat-datepicker>
                </mat-form-field>

                <div
                  class="invalid-feedback d-block"
                  *ngIf="resumo.controls.initialDate.invalid && isSubmitted"
                >
                  {{ "common.initialDateRequired" | translate }}
                </div>
              </div>
            </div>

            <div class="col-xl col-lg-6 col-sm-6">
              <div class="form-group">
                <label class="form-label">
                  {{ "common.finalDate" | translate }}
                </label>

                <mat-form-field
                  appearance="fill"
                  class="w-100 date-align custom-datetime"
                >
                  <input
                    #endText
                    matInput
                    [matDatepicker]="pickerFim"
                    placeholder="DD/MM/YYYY"
                    [formControl]="resumo.controls.endDate"
                    (input)="endRaw = endText.value"
                    (dateChange)="onDateChange('endDate', endText.value)"
                    (blur)="parseDateInput('endDate', endRaw)"
                    (keydown.enter)="parseDateInput('endDate', endRaw)"
                  />
                  <mat-datepicker-toggle
                    matSuffix
                    [for]="pickerFim"
                  ></mat-datepicker-toggle>
                  <mat-datepicker #pickerFim startView="month"></mat-datepicker>
                </mat-form-field>

                <div
                  class="invalid-feedback d-block"
                  *ngIf="resumo.controls.endDate.invalid && isSubmitted"
                >
                  {{ "common.finalDateRequired" | translate }}
                </div>
              </div>
            </div>

            <div class="col-xl-1 col-lg-6 col-sm-6">
              <button
                type="button"
                class="our-button btn btn-pill btn-primary"
                (click)="buscar(startRaw, endRaw)"
              >
                <i class="fe fe-search me-2"></i>
                {{ "common.searchButton" | translate }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="loading-extrato" *ngIf="!isLoaded">
      <div class="dimmer active">
        <div class="lds-ring">
          <div></div>
        </div>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-12">
      <div class="card sales-summary rounded-10 shadow">
        <div class="card-header">
          <div class="card-title mb-0">
            Resumo
          </div>
          <div class="card-options">
            <button
              type="button"
              class="btn btn-pill btn-default-light"
              (click)="downloadFile()"
            >
              <i class="fe fe-download me-2"></i>Exportar PDF
            </button>
          </div>
        </div>

        <div class="card-body button-table">
          <app-table-summary (loaded)="isLoaded = true"></app-table-summary>
        </div>
      </div>
    </div>
  </div>
</form>